/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import {
  RevocationResponseOutput,
  SessionPageResponseOutput,
  UserDirectoryDetailResponseOutput,
  UserDirectoryPageResponseOutput,
  UserMembershipPageResponseOutput,
  UserResponseOutput,
} from '../model';
import type {
  ChangeRoleBody,
  EmptyCommand,
  ListMembershipsParams,
  ListSessionsParams,
  ListUsersParams,
} from '../model';

import { validatedFetch } from '../../client';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getListUsersUrl = (params?: ListUsersParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/access/users?${stringifiedParams}`
    : `/api/v1/access/users`;
};

export const listUsers = async (
  params?: ListUsersParams,
  options?: Parameters<typeof validatedFetch>[1],
): Promise<UserDirectoryPageResponseOutput> => {
  return validatedFetch<UserDirectoryPageResponseOutput>(getListUsersUrl(params), {
    ...options,
    method: 'GET',

    schema: UserDirectoryPageResponseOutput,
  });
};

export const getListUsersQueryKey = (params?: ListUsersParams) => {
  return [`/api/v1/access/users`, ...(params ? [params] : [])] as const;
};

export const getListUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof listUsers>>,
  TError = unknown,
>(
  params?: ListUsersParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>;
    request?: SecondParameter<typeof validatedFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListUsersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listUsers>>> = ({ signal }) =>
    listUsers(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listUsers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListUsersQueryResult = NonNullable<Awaited<ReturnType<typeof listUsers>>>;
export type ListUsersQueryError = unknown;

export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = unknown>(
  params?: ListUsersParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>;
    request?: SecondParameter<typeof validatedFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListUsersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getListMembershipsUrl = (userId: string, params?: ListMembershipsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/access/users/${userId}/memberships?${stringifiedParams}`
    : `/api/v1/access/users/${userId}/memberships`;
};

export const listMemberships = async (
  userId: string,
  params?: ListMembershipsParams,
  options?: Parameters<typeof validatedFetch>[1],
): Promise<UserMembershipPageResponseOutput> => {
  return validatedFetch<UserMembershipPageResponseOutput>(getListMembershipsUrl(userId, params), {
    ...options,
    method: 'GET',

    schema: UserMembershipPageResponseOutput,
  });
};

export const getListMembershipsQueryKey = (userId: string, params?: ListMembershipsParams) => {
  return [`/api/v1/access/users/${userId}/memberships`, ...(params ? [params] : [])] as const;
};

export const getListMembershipsQueryOptions = <
  TData = Awaited<ReturnType<typeof listMemberships>>,
  TError = unknown,
>(
  userId: string,
  params?: ListMembershipsParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listMemberships>>, TError, TData>;
    request?: SecondParameter<typeof validatedFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMembershipsQueryKey(userId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMemberships>>> = ({ signal }) =>
    listMemberships(userId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: userId !== null && userId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof listMemberships>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type ListMembershipsQueryResult = NonNullable<Awaited<ReturnType<typeof listMemberships>>>;
export type ListMembershipsQueryError = unknown;

export function useListMemberships<
  TData = Awaited<ReturnType<typeof listMemberships>>,
  TError = unknown,
>(
  userId: string,
  params?: ListMembershipsParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listMemberships>>, TError, TData>;
    request?: SecondParameter<typeof validatedFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListMembershipsQueryOptions(userId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetUserUrl = (userId: string) => {
  return `/api/v1/access/users/${userId}`;
};

export const getUser = async (
  userId: string,
  options?: Parameters<typeof validatedFetch>[1],
): Promise<UserDirectoryDetailResponseOutput> => {
  return validatedFetch<UserDirectoryDetailResponseOutput>(getGetUserUrl(userId), {
    ...options,
    method: 'GET',

    schema: UserDirectoryDetailResponseOutput,
  });
};

export const getGetUserQueryKey = (userId: string) => {
  return [`/api/v1/access/users/${userId}`] as const;
};

export const getGetUserQueryOptions = <
  TData = Awaited<ReturnType<typeof getUser>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>;
    request?: SecondParameter<typeof validatedFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserQueryKey(userId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUser>>> = ({ signal }) =>
    getUser(userId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: userId !== null && userId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData> & { queryKey: QueryKey };
};

export type GetUserQueryResult = NonNullable<Awaited<ReturnType<typeof getUser>>>;
export type GetUserQueryError = unknown;

export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = unknown>(
  userId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>;
    request?: SecondParameter<typeof validatedFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetUserQueryOptions(userId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getUpdateRoleUrl = (userId: string) => {
  return `/api/v1/access/users/${userId}/role`;
};

export const updateRole = async (
  userId: string,
  changeRoleBody: ChangeRoleBody,
  options?: Parameters<typeof validatedFetch>[1],
): Promise<UserResponseOutput> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return validatedFetch<UserResponseOutput>(getUpdateRoleUrl(userId), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(changeRoleBody),
    schema: UserResponseOutput,
  });
};

export const getUpdateRoleMutationKey = () => ['updateRole'] as const;

export const getUpdateRoleMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateRole>>,
    TError,
    UpdateRoleMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof validatedFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateRole>>,
  TError,
  UpdateRoleMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateRoleMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateRole>>,
    UpdateRoleMutationVariables
  > = (props) => {
    const { userId, data } = props ?? {};

    return updateRole(userId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateRoleMutationResult = NonNullable<Awaited<ReturnType<typeof updateRole>>>;
export type UpdateRoleMutationBody = ChangeRoleBody;
export type UpdateRoleMutationError = unknown;
export type UpdateRoleMutationVariables = { userId: string; data: ChangeRoleBody };

export const useUpdateRole = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateRole>>,
    TError,
    UpdateRoleMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof validatedFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateRole>>,
  TError,
  UpdateRoleMutationVariables,
  TContext
> => {
  return useMutation(getUpdateRoleMutationOptions(options));
};
export const getListSessionsUrl = (params?: ListSessionsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/access/sessions?${stringifiedParams}`
    : `/api/v1/access/sessions`;
};

export const listSessions = async (
  params?: ListSessionsParams,
  options?: Parameters<typeof validatedFetch>[1],
): Promise<SessionPageResponseOutput> => {
  return validatedFetch<SessionPageResponseOutput>(getListSessionsUrl(params), {
    ...options,
    method: 'GET',

    schema: SessionPageResponseOutput,
  });
};

export const getListSessionsQueryKey = (params?: ListSessionsParams) => {
  return [`/api/v1/access/sessions`, ...(params ? [params] : [])] as const;
};

export const getListSessionsQueryOptions = <
  TData = Awaited<ReturnType<typeof listSessions>>,
  TError = unknown,
>(
  params?: ListSessionsParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listSessions>>, TError, TData>;
    request?: SecondParameter<typeof validatedFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSessionsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSessions>>> = ({ signal }) =>
    listSessions(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSessions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSessionsQueryResult = NonNullable<Awaited<ReturnType<typeof listSessions>>>;
export type ListSessionsQueryError = unknown;

export function useListSessions<TData = Awaited<ReturnType<typeof listSessions>>, TError = unknown>(
  params?: ListSessionsParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listSessions>>, TError, TData>;
    request?: SecondParameter<typeof validatedFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListSessionsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getRevokeUrl = (sessionId: string) => {
  return `/api/v1/access/sessions/${sessionId}/revoke`;
};

export const revoke = async (
  sessionId: string,
  emptyCommand: EmptyCommand,
  options?: Parameters<typeof validatedFetch>[1],
): Promise<RevocationResponseOutput> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return validatedFetch<RevocationResponseOutput>(getRevokeUrl(sessionId), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(emptyCommand),
    schema: RevocationResponseOutput,
  });
};

export const getRevokeMutationKey = () => ['revoke'] as const;

export const getRevokeMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revoke>>,
    TError,
    RevokeMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof validatedFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof revoke>>,
  TError,
  RevokeMutationVariables,
  TContext
> => {
  const mutationKey = getRevokeMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof revoke>>,
    RevokeMutationVariables
  > = (props) => {
    const { sessionId, data } = props ?? {};

    return revoke(sessionId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RevokeMutationResult = NonNullable<Awaited<ReturnType<typeof revoke>>>;
export type RevokeMutationBody = EmptyCommand;
export type RevokeMutationError = unknown;
export type RevokeMutationVariables = { sessionId: string; data: EmptyCommand };

export const useRevoke = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revoke>>,
    TError,
    RevokeMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof validatedFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof revoke>>,
  TError,
  RevokeMutationVariables,
  TContext
> => {
  return useMutation(getRevokeMutationOptions(options));
};
